import 'resize-observer-polyfill/dist/ResizeObserver.global';
import packageJson from '../../package.json';

global.appVersion = packageJson.version;
